import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { SelectChangeEvent } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useMemo } from 'react';
import { useController } from 'react-hook-form';

import { useHasBrandEngineFeatureFlag } from 'reservations/account/hooks/featureFlags';
import { useBookingConfig } from 'reservations/account/providers/ConfigProvider';
import { trackPartySizeSelection } from 'reservations/analytics/helpers';
import { getNumberOfGuestsOptions } from 'reservations/availabilities/helpers/getNumberOfGuestsOptions';
import { getAvailabilitiesFormItemStyles } from 'reservations/brand/helpers/v1/styles';
import { useBookingForm } from 'reservations/form/providers/BookingFormProvider';

const PartySize = () => {
  const { partySizeMax: max, partySizeMin: min } = useBookingConfig();
  const {
    field: { onChange, onBlur, name, value, ref }
  } = useController({
    name: 'partySize'
  });
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();

  const options = useMemo(() => getNumberOfGuestsOptions(min, max), [max, min]);
  const { submissionType } = useBookingForm();

  const handleChange = (event: SelectChangeEvent<any>) => {
    const currentPartySize = event.target.value;
    trackPartySizeSelection(submissionType, currentPartySize);
    onChange(event);
  };

  return (
    <FormControl
      fullWidth
      sx={getAvailabilitiesFormItemStyles(hasBrandEngineFeature)}
    >
      <InputLabel id="reservations-guests">Guests</InputLabel>
      <Select
        data-testid="select-guests-parent"
        inputProps={{ 'data-testid': 'select-guests' }}
        labelId="reservations-guests"
        onChange={handleChange}
        onBlur={onBlur}
        value={value}
        name={name}
        inputRef={ref}
        label="Guests"
        IconComponent={KeyboardArrowDownIcon}
        startAdornment={
          <InputAdornment position="start">
            <PersonOutlineIcon />
          </InputAdornment>
        }
      >
        {options.map(option => (
          <MenuItem value={option} key={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PartySize;
